export const billingFeesFieldGroup = [
  'leaseFeePercentage',
  'leaseFeeMinAmount',
  'leaseFeeMaxAmount',
  'leaseFeeThirdPartyAccepted',
  'leaseFeeThirdPartyPercentage',
  'withdrawalFee',
  'failedSetupFee',
  'renewalFeePercentage',
  'renewalFeeMinAmount',
  'virtualTourFee',
  'discountLongDOM',
  'longDOMThreshold',
  'longDOMLeaseFeePercentage',
];
